import React from "react";

export default function AssignModal({
  show,
  onClose,
  teams,
  assignTab,
  setAssignTab,
  selectedAssignTeam,
  setSelectedAssignTeam,
  teamDrivers,
  allTeamDrivers,
  selectedAgentId,
  setSelectedAgentId,
  handleAssignTask,
}) {
  if (!show) return null;

  const drivers = assignTab === "team" ? teamDrivers : allTeamDrivers;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
      <div className="bg-white p-4 rounded shadow-lg w-[95%] max-w-3xl max-h-[90vh] flex flex-col overflow-hidden">
        <h2 className="text-lg font-semibold mb-3 flex-shrink-0">Assign Driver</h2>

        {/* Tabs */}
        <div className="flex gap-2 mb-3 flex-shrink-0">
          <button
            onClick={() => setAssignTab("team")}
            className={`px-4 py-2 rounded ${
              assignTab === "team" ? "bg-orange-500 text-white" : "bg-gray-200"
            }`}
          >
            Team Members
          </button>

          <button
            onClick={() => setAssignTab("all")}
            className={`px-4 py-2 rounded ${
              assignTab === "all" ? "bg-orange-500 text-white" : "bg-gray-200"
            }`}
          >
            All Drivers
          </button>
        </div>

        {/* All Teams list (only when All Drivers tab) */}
        {assignTab === "all" && (
          <div className="grid grid-cols-3 gap-3 mb-3 max-h-48 overflow-y-auto flex-shrink-0">
            {(teams || []).map((t) => (
              <div
                key={t.team_name}
                onClick={() => setSelectedAssignTeam(t.team_name)}
                className={`p-3 border rounded cursor-pointer text-center font-medium ${
                  selectedAssignTeam === t.team_name
                    ? "border-orange-500 bg-orange-50"
                    : "hover:bg-gray-100"
                }`}
              >
                {t.team_name}
              </div>
            ))}
          </div>
        )}

        {/* Driver List */}
        <div className="flex-1 overflow-auto">
          <div className="grid grid-cols-3 gap-3 mb-3 mt-5">
            {(drivers || []).map((driver) => (
              <div
                key={driver.driverId}
                onClick={() => {
                  if (driver.dutyStatus === "offline") return;
                  setSelectedAgentId(driver.driverId);
                }}
                className={`p-3 border rounded cursor-pointer flex justify-between items-center ${
                  selectedAgentId === driver.driverId
                    ? "border-orange-500 bg-orange-50"
                    : "hover:bg-gray-100"
                } ${driver.dutyStatus === "offline" ? "opacity-50 cursor-not-allowed" : ""}`}
              >
                <div>
                  <p className="font-medium">{driver.fullName}</p>
                  <p className="text-xs text-gray-500">{driver.dutyStatus}</p>
                </div>
              </div>
            ))}
          </div>

          {(!drivers || drivers.length === 0) && (
            <div className="text-center text-gray-400 text-sm py-4">No drivers available</div>
          )}
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-3 mt-4 flex-shrink-0">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded"
          >
            Cancel
          </button>

          <button
            onClick={handleAssignTask}
            disabled={!selectedAgentId}
            className="px-4 py-2 bg-orange-500 text-white rounded disabled:opacity-50"
          >
            Assign
          </button>
        </div>
      </div>
    </div>
  );
}
